"use client";
import { AuthContextProvider } from "./auth-context";

export default ({ children }) => {
  return (
      <AuthContextProvider>
        {children}
      </AuthContextProvider>
  );
};